import { render, staticRenderFns } from "./ComponentInput.vue?vue&type=template&id=71151e7c&scoped=true"
import script from "./ComponentInput.vue?vue&type=script&lang=js"
export * from "./ComponentInput.vue?vue&type=script&lang=js"
import style0 from "./ComponentInput.vue?vue&type=style&index=0&id=71151e7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71151e7c",
  null
  
)

export default component.exports